export default __webpack_public_path__ + "static/media/TaxInvoice.8f1953b1.svg";